import React, { useState, useEffect } from "react";
import { Outlet, useLocation, useNavigate, NavLink, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { MapPin, Package, LogOut, Home, Croissant, BarChart3 } from "lucide-react";

export default function MobileLayout() {
  const { user, loading, logout } = useAuth();
  const loc = useLocation();
  const navigate = useNavigate();

  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#2C1810] text-[#FDFBF7]">Loading…</div>;
  if (!user) return <Navigate to="/m/login" replace />;

  const isOwner = ["super_admin", "admin", "manager"].includes(user.role) || !user.branch_id;

  return (
    <div className="min-h-screen bg-[#FDFBF7] text-[#2C1810] flex flex-col max-w-md mx-auto shadow-2xl">
      {/* Top bar */}
      <header className="h-14 bg-[#2C1810] text-[#FDFBF7] flex items-center justify-between px-4 sticky top-0 z-30">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded bg-[#C05621] flex items-center justify-center">
            <Croissant className="w-4 h-4" />
          </div>
          <div className="leading-tight">
            <div className="text-sm font-semibold font-[Outfit]">Bakemill Field</div>
            <div className="text-[9px] uppercase tracking-widest text-[#C8B8A0]">{user.name}</div>
          </div>
        </div>
        <button
          onClick={logout}
          data-testid="m-logout-btn"
          className="p-2 rounded hover:bg-[#3a2418]"
        >
          <LogOut className="w-4 h-4" />
        </button>
      </header>

      <main className="flex-1 overflow-y-auto pb-20" data-testid="m-main-content">
        <Outlet />
      </main>

      {/* Bottom nav */}
      <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-white border-t border-[#EAE5D9] flex items-center justify-around h-16 z-30">
        <MobileTab to="/m/home" icon={Home} label="Home" testid="m-tab-home" />
        <MobileTab to="/m/checkin" icon={MapPin} label="Check-in" testid="m-tab-checkin" />
        <MobileTab to="/m/deliveries" icon={Package} label="Deliveries" testid="m-tab-deliveries" />
        {isOwner && <MobileTab to="/m/owner" icon={BarChart3} label="Owner" testid="m-tab-owner" />}
      </nav>
    </div>
  );
}

function MobileTab({ to, icon: Icon, label, testid }) {
  return (
    <NavLink
      to={to}
      data-testid={testid}
      className={({ isActive }) =>
        `flex flex-col items-center gap-0.5 px-4 py-2 text-[11px] font-medium ${
          isActive ? "text-[#C05621]" : "text-[#8B7355]"
        }`
      }
    >
      <Icon className="w-5 h-5" />
      <span>{label}</span>
    </NavLink>
  );
}
